module.exports = __webpack_public_path__ + "static/media/photo-exukonline-experience.19d836cb.jpeg";